import { Component, ViewChild, OnInit, OnDestroy } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import { environment } from "../../environments/environment";
import { SipService } from "../sip/sip.service";
import { WsService } from "../ws/ws.service";
import { WorkflowService } from "../workflow/workflow.service";
import { ErrorService } from "../errorbar/error.service";
import { HttpClient } from "@angular/common/http";

enum VoiceMailStep {
  NONE = 1,
  NEEDCHOOSE = 2,
  SELECTED = 3,
}
@Component({
  selector: "app-call",
  templateUrl: "./call.component.html",
  styleUrls: ["./call.component.scss"],
})
export class CallComponent implements OnInit, OnDestroy {
  public ST: any;
  public state: any;
  public user: any;
  public client: any;
  public workflow: any;
  private stateSubscription: Subscription;
  private userSubscription: Subscription;
  private clientSubscription: Subscription;
  private sipStateSubscription: Subscription;
  private testSubscription: Subscription;
  private testPassSubscription: Subscription;
  private connectSubscription: Subscription;

  public permissionWarning: boolean;
  public permissionError: boolean;
  public permissionFailure: boolean;
  public permissionTimeout: number;
  public permissionTimer: any;
  public testPassed: boolean;
  public testPackets: number;
  public testProgress: number;
  public testPacketsReceived: number;
  public testPacketsSended: number;
  public hangupLocked: boolean;
  public saveLocked: boolean;
  public pauseLocked: boolean;
  public smsMechanicLocked: boolean;
  public callIdle: boolean;
  public callIdleTimeout: number;
  public callIdleWatchdog: any;
  public VoiceMailStep = VoiceMailStep;
  public voiceMailStep: VoiceMailStep;
  public VOICEMAIL_RESULTS = [-29, 103, 113, 129, 147]
  public voiceMailResultId = 0;

  @ViewChild("clientForm") clientForm: NgForm;

  constructor(
    private ws: WsService,
    private wfs: WorkflowService,
    private sip: SipService,
    private err: ErrorService,
    private http: HttpClient
  ) {
    this.ST = this.ws.ST;
    this.state = this.ws.getState();
    this.user = this.ws.getUser();
    this.client = this.ws.getClient();
    this.workflow = null;
    this.permissionWarning = false;
    this.permissionError = false;
    this.permissionFailure = false;
    this.permissionTimeout = 15;
    this.hangupLocked = false;
    this.saveLocked = false;
    this.pauseLocked = false;
    this.smsMechanicLocked = false;
    this.callIdle = false;
    this.testPassed = false;
    this.testPackets = 0;
    this.testProgress = 0;
    this.testPacketsReceived = 0;
    this.testPacketsSended = 0;
    this.callIdleTimeout = 15;
    this.stateSubscription = this.ws.onState.subscribe(
      this.onChangeState.bind(this)
    );
    this.userSubscription = this.ws.onUser.subscribe(this.onUser.bind(this));
    this.clientSubscription = this.ws.onClient.subscribe(
      this.onClient.bind(this)
    );
    this.sipStateSubscription = this.sip.onSipState.subscribe(
      this.onSipState.bind(this)
    );
    this.testPassSubscription = this.ws.events.test_passed.subscribe(
      this.onTestPassed.bind(this)
    );
    this.testSubscription = this.ws.events.test.subscribe(
      this.onTestEvent.bind(this)
    );
    this.connectSubscription = this.ws.onConnect.subscribe(
      this.onConnect.bind(this)
    );

    this.workflow = this.wfs.getWorkflow({});
    this.voiceMailResultId = this.workflow.options.find((o) => this.VOICEMAIL_RESULTS.includes(o.id))?.id || 0;
    this.voiceMailStep = VoiceMailStep.NONE;
  }

  private onChangeState(state: any): void {
    console.log('____________', state)
    this.state = state;
    if (
      [
        this.ST.UNAUTHORIZED,
        this.ST.INACTIVE,
        this.ST.INITWEBRTC,
        this.ST.READY,
        this.ST.INVITEACCEPTED,
      ].indexOf(this.state) > -1
    ) {
      this.workflow = this.wfs.getWorkflow({});
      this.voiceMailResultId = this.workflow.options.find((o) => this.VOICEMAIL_RESULTS.includes(o.id))?.id || 0;
      this.err.logError("debug", "CallComponent: Clearing client profile");
    }
    this.hangupLocked = false;
    this.saveLocked = false;
    this.pauseLocked = false;
    this.testPassed = false;
    this.testPackets = 0;
    this.testProgress = 0;
    this.testPacketsReceived = 0;
    this.callIdle = false;
    clearTimeout(this.callIdleWatchdog);
    if (this.state === this.ST.RINGING) {
      this.callIdleWatchdog = setTimeout(
        this.onCallIdleTimer.bind(this),
        this.callIdleTimeout * 1000
      );
    }
  }

  private onUser(user: any): void {
    this.user = user;
  }

  private onClient(client: any): void {
    this.client = client;
    this.workflow = this.wfs.getWorkflow(client);
    this.voiceMailResultId = this.workflow.options.find((o) => this.VOICEMAIL_RESULTS.includes(o.id))?.id || 0;
    this.smsMechanicLocked = false;
  }

  private onSipState(state: any): void {
    if (state) {
      if (!this.permissionWarning && state.permission === "request") {
        this.permissionFailure = false;
        clearTimeout(this.permissionTimer);
        this.permissionTimer = setTimeout(
          this.onPermissionTimer.bind(this),
          this.permissionTimeout * 1000
        );
      }
      if (this.permissionFailure && state.permission === "error") {
        this.permissionFailure = false;
      }
      this.permissionWarning = state.permission === "request" ? true : false;
      this.permissionError = state.permission === "error" ? true : false;
      if (!this.permissionWarning) {
        clearTimeout(this.permissionTimer);
      }
    }
  }

  private onPermissionTimer(): void {
    if (this.permissionWarning) {
      this.permissionWarning = false;
      this.permissionError = false;
      this.permissionFailure = true;
    }
  }

  private onCallIdleTimer(): void {
    if (this.state === this.ST.RINGING) {
      this.callIdle = true;
      this.err.logError("debug", "CallComponent: Idle call detected");
    }
  }

  private onTestPassed(data: any): void {
    this.testPassed = true;
  }

  private onTestEvent(data: any): void {
    console.log(data);
    if (
      data &&
      (data.hasOwnProperty("received") || data.hasOwnProperty("sended"))
    ) {
      this.testPacketsSended = data.received > 10 ? 10 : data.received;
      this.testPacketsReceived = data.sended > 10 ? 10 : data.sended;
      this.testPackets = this.testPacketsSended + this.testPacketsReceived;
      let maxPackets = 20;
      if (this.user && this.user.hasOwnProperty("test_packets")) {
        maxPackets = this.user.test_packets;
      }
      this.testProgress = Math.min(
        100,
        Math.ceil((100 * this.testPackets) / maxPackets)
      );
    }
  }

  private onConnect(): void {
    this.hangupLocked = false;
    this.saveLocked = false;
    this.pauseLocked = false;
  }

  public unpause(): void {
    if (!this.pauseLocked) {
      this.pauseLocked = true;
      this.ws.methodPause(false);
    }
  }

  public processClient(form: any, callback_state: number): void {
    this.err.logError("debug", "CallComponent: SaveResult Button clicked");
    if (form && !this.saveLocked) {
      const result: any = {
        text: form.value.comment,
        id_result: form.value.option,
        to_state: callback_state,
      };
      if (form.value.datetime) {
        result.call_datetime = this.formatServerDateTime(form.value.datetime);
      }
      if (form.value.messenger) {
        result.id_link = form.value.messenger;
      }
      if (form.value.messenger_username) {
        result.link_username = form.value.messenger_username;
      }
      if (form.value.action) {
        result.id_offer = form.value.action;
      }
      if (form.value.dont_call) {
        result.dont_call = 1;
      }
      const maxQuestions = 10;
      for (let j = 0; j < maxQuestions; j++) {
        const questionKey = "question_" + j;
        if (form.value[questionKey]) {
          result[questionKey] = form.value[questionKey];
        }
      }
      console.log(result, "__________________");
      this.ws.methodSaveCallResult(result);
      this.saveLocked = true;
      this.voiceMailStep = VoiceMailStep.NONE;
    }
  }

  public redirectClient(form: any): void {
    this.err.logError("debug", "CallComponent: RedirectCall Button clicked");
    if (form && !this.hangupLocked) {
      this.ws.methodRedirectCall({ comment: form.value.comment });
      this.hangupLocked = true;
    }
  }

  public terminateCall(): void {
    this.err.logError("debug", "CallComponent: TerminateCall Button clicked");
    if (!this.hangupLocked) {
      this.sip.terminateCall();
      this.hangupLocked = true;
    }
  }

  public leaveIdleCall(): void {
    this.err.logError("debug", "CallComponent: leaveIdleCall Button clicked");
    this.sip.leaveIdleCall();
  }

  public activateSmsMechanic(mechanicId: number): void {
    if (!this.smsMechanicLocked) {
      this.smsMechanicLocked = true;
      this.ws.methodSmsMechanic(mechanicId);
    }
  }

  private formatServerDateTime(d: any): any {
    if (!d || !d.toISOString) {
      return "";
    }
    const mskDatetime = new Date(
      d.valueOf() + environment.SERVER_TZ_OFFSET * 1000
    );
    const isoString = mskDatetime.toISOString();
    return (
      isoString.substring(8, 10) +
      "." +
      isoString.substring(5, 7) +
      "." +
      isoString.substring(0, 4) +
      " " +
      isoString.substring(11, 13) +
      ":" +
      isoString.substring(14, 16) +
      ":" +
      isoString.substring(17, 19)
    );
  }

  public gotoVoiceMailStep(step: VoiceMailStep): void {
    this.voiceMailStep = step;
    switch (step) {
      case VoiceMailStep.NONE: {
        break;
      }
      case VoiceMailStep.NEEDCHOOSE: {
        break;
      }
      case VoiceMailStep.SELECTED: {
        this.terminateCall();
        this.clientForm.value.option = this.voiceMailResultId || 129;
        console.log(this.clientForm, "____________");
        break;
      }
    }
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.stateSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
    this.clientSubscription.unsubscribe();
    this.sipStateSubscription.unsubscribe();
    this.testSubscription.unsubscribe();
    this.testPassSubscription.unsubscribe();
    this.connectSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/call/call.component.ts